<app-dialog-layout>
  <ng-container content>
    <div>
      @if (form) {
        <form [formGroup]="form">
          <cap-password formControlName="password" [toggleMask]="true" [autofocus]="true" />
        </form>
      }
    </div>
  </ng-container>

  <ng-container buttons>
    <cap-button
      [attr.data-test]="'application-cancel-button-cancel'"
      styleClass="secondary"
      [label]="'button.cancel' | translate"
      (onClick)="close()" />

    <cap-button
      [attr.data-test]="'application-create-button-add'"
      styleClass="primary"
      [disabled]="!form?.valid"
      [label]="'button.submit' | translate"
      (onClick)="submit()" />
  </ng-container>
</app-dialog-layout>
